module.exports = __webpack_public_path__ + "img/f-10.b29a4559.jpg";